<template>
    <div v-if="selectedElement && selectedElement.itemType != 'page_element'" class="editor-template-data-properties">
        <div class="editor-template-data-properties-header">
            <h2>Pulling data</h2>
        </div>
        <div class="editor-template-data-properties-body">
            <EditorProperty title="Origin" class="veritical">
                <DropdownWidget v-if="selectedElement.itemType == 'container_element' && dataOriginOwner == 'profile'"
                    style="width: 100%;" :options="dataOriginOptions" :value="selectedDataOriginValue"
                    @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'profile'" style="width: 100%;"
                    :options="selectedElement.itemType == 'image_element' ? profileImageDataOriginOptions : profileDataOriginOptions"
                    :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'projects'" style="width: 100%;"
                    :options="projectDataOriginOptions" :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'employments'" style="width: 100%;"
                    :options="employmentDataOriginOptions" :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'educations'" style="width: 100%;"
                    :options="educationDataOriginOptions" :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'trainings'" style="width: 100%;"
                    :options="trainingDataOriginOptions" :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget v-else-if="dataOriginOwner == 'certification'" style="width: 100%;"
                    :options="certificationDataOriginOptions" :value="selectedDataOriginValue" @input="onDataOriginChange">
                </DropdownWidget>
                <DropdownWidget
                    v-else-if="dataOriginOwner == 'skills' || (selectedElement.itemType != 'container_element' && dataOriginOwner == 'project_skills') || (selectedElement.itemType != 'container_element' && dataOriginOwner == 'employment_skills')"
                    style="width: 100%;" :options="skillDataOriginOptions" :value="selectedDataOriginValue"
                    @input="onDataOriginChange">
                </DropdownWidget>
            </EditorProperty>
            <EditorProperty v-if="selectedElement.itemType == 'container_element' && selectedDataOriginValue != ''"
                title="Number of items">
                <NumberWidget style="width: 100%;" :min="1" :max="20" :value="numberOfItems" @input="onNumberItemsChange">
                </NumberWidget>
            </EditorProperty>
        </div>
    </div>
    <div v-else class="editor-template-data-properties">
    </div>
</template>
<script>
import EditorProperty from "./editor_components/editor_property.vue"
import DropdownWidget from "./input-widget/dropdown_widget.vue"
import NumberWidget from "./input-widget/number_widget.vue"
export default {
    name: "editor-template-data-properties",
    components: {
        EditorProperty,
        DropdownWidget,
        NumberWidget,
    },
    props: {
        selectedElement: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },
    data() {
        return {
            dataOriginOptions: [
                { value: '', label: 'None' },
                { value: 'projects', label: 'Projects' },
                { value: 'employments', label: 'Employments' },
                { value: 'educations', label: 'Educations' },
                { value: 'trainings', label: 'Trainings' },
                { value: 'certifications', label: 'Certifications' },
                { value: 'skills', label: 'Skills' },
            ],
            profileDataOriginOptions: [
                { value: 'profile_first_name', label: 'Profile First Name' },
                { value: 'profile_last_name', label: 'Profile Last Name' },
                { value: 'profile_email', label: 'Profile Email' },
                { value: 'profile_phone', label: 'Profile Phone' },
                { value: 'profile_address', label: 'Profile Address' },
                { value: 'profile_description', label: 'Profile Description' },
            ],
            profileImageDataOriginOptions: [
                { value: 'profile_image', label: 'Profile Image' },
                { value: 'profile_icon', label: 'Profile Icon' },
            ],
            educationDataOriginOptions: [
                { value: 'education_school', label: 'Education Institution' },
                { value: 'education_degree', label: 'Education Degree' },
                { value: 'education_address', label: 'Education Address' },
                { value: 'education_start_date', label: 'Education Start Date' },
                { value: 'education_end_date', label: 'Education End Date' },
            ],
            trainingDataOriginOptions: [
                { value: 'training_certificate', label: 'Training Certificate' },
                { value: 'training_institution', label: 'Training Institution' },
                { value: 'training_address', label: 'Training Address' },
                { value: 'training_start_date', label: 'Training Start Date' },
                { value: 'training_end_date', label: 'Training End Date' },
            ],
            certificationDataOriginOptions: [
                { value: 'certification_name', label: 'Certification Name' },
                { value: 'certification_institution', label: 'Certification Institution' },
                { value: 'certification_date', label: 'Date of Certification' },
                { value: 'certification_description', label: 'Certification Description' },
            ],
            skillDataOriginOptions: [
                { value: 'name', label: 'Skill Name' },
                { value: 'level', label: 'Skill Level' },
            ],
        };
    },
    computed: {
        projectDataOriginOptions() {
            let vm = this;
            if (vm.selectedElement.itemType == 'container_element') {
                return [
                    { value: 'project_skills', label: 'Project Skills' },
                ];
            }
            return [
                { value: 'project_name', label: 'Project Name' },
                { value: 'project_company', label: 'Project Company' },
                { value: 'project_address', label: 'Project Address' },
                { value: 'project_description', label: 'Project Description' },
                { value: 'project_start_date', label: 'Project Start Date' },
                { value: 'project_end_date', label: 'Project End Date' },
            ];
        },
        employmentDataOriginOptions() {
            let vm = this;
            if (vm.selectedElement.itemType == 'container_element') {
                return [
                    { value: 'employment_skills', label: 'Employment Skills' }
                ]
            }
            return [
                { value: 'employment_company', label: 'Employment Company' },
                { value: 'employment_position', label: 'Employment Position' },
                { value: 'employment_address', label: 'Employment Address' },
                { value: 'employment_description', label: 'Employment Description' },
                { value: 'employment_start_date', label: 'Employment Start Date' },
                { value: 'employment_end_date', label: 'Employment End Date' },
            ];
        },
        selectedDataOriginValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let dataOrigin = selectedElement.dataOrigin;
                if (dataOrigin) {
                    return dataOrigin;
                }
            }
            return '';
        },
        numberOfItems() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let numberOfItems = selectedElement.numberOfItems;
                if (numberOfItems) {
                    return numberOfItems;
                }
            }
            return 0;
        },
        dataOriginOwner() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let dataOriginOwner = selectedElement.dataOriginOwner;
                if (dataOriginOwner) {
                    return dataOriginOwner;
                }
            }
            return '';
        },
    },
    mounted() { },
    methods: {
        onDataOriginChange(value) {
            let vm = this;
            vm.$emit('onDataOriginChange',
                {
                    dataOriginOwner: vm.dataOriginOwner,
                    dataOrigin: value
                });
        },
        onNumberItemsChange(value) {
            let vm = this;
            if (value) {
                vm.$emit('onNumberItemsChange', value ? value : 0);
            }
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.editor-template-data-properties-body {
    padding: 0px 10px;
}
</style>